// import { AuthService } from '../auth.service';
import { Injectable, Inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(@Inject('BASE_API_URL') private baseApiUrl: string /*private auth: AuthService*/) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    // Get the auth token from the service.
    // const authToken = this.auth.getAuthorizationToken();

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    const authReq = req.clone({
      headers: req.headers.set('Name', 'Leo H.'),
      url: `${this.baseApiUrl}${req.url}`
    });


    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
